/**
 * Tradução, na EXIBIÇÃO, dos valores que o backend grava em português.
 *
 * O backend normaliza alguns campos para valores canônicos em pt-BR —
 * `tipo_pagamento` vira "Dinheiro"/"Cartão"/"Pix", `nome_cliente` vira
 * "Não informado", e o lançamento de abertura de caixa recebe a descrição
 * "Saldo Inicial". Numa loja em inglês esses valores aparecem em português no
 * meio da tela traduzida.
 *
 * POR QUE TRADUZIR AQUI E NÃO NA GRAVAÇÃO
 * Esses valores são SENTINELAS de lógica, não rótulos. O próprio backend
 * compara contra eles — `caixaV2.js` decide o que é venda com
 * `descricao !== "Saldo Inicial"` em três lugares, e o front filtra cliente com
 * `nome !== 'Não informado'`. Traduzir na gravação quebraria essas comparações,
 * e os registros ANTIGOS continuariam em português de qualquer forma. Traduzir
 * na exibição resolve o histórico junto e não toca em nenhum dado.
 *
 * Espelhado em garcomapp-front/src/utils/sentinelas.js.
 */
import i18n from '../i18n';

/** Sentinela (minúsculo, sem acento) -> chave de tradução. */
const MAPA = {
  'nao informado': 'common:labels.notInformed',
  'dinheiro': 'common:paymentMethods.cash',
  'cartao': 'common:paymentMethods.card',
  'cartaoonline': 'common:paymentMethods.cardOnline',
  'cartao de credito': 'common:paymentMethods.credit',
  'cartao de debito': 'common:paymentMethods.debit',
  'pix': 'common:paymentMethods.pix',
  'saldo inicial': 'common:cashEntries.openingBalance',
  'gorjeta': 'common:cashEntries.tip',
};

const normalizar = (v) =>
  String(v)
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '');

/**
 * Devolve o texto pronto para a tela.
 * Valor não reconhecido volta como está — nunca some da interface.
 *
 * @param {*} valor - o que veio do backend
 * @param {string} [padrao] - o que mostrar quando o valor é vazio/nulo
 */
export function exibirSentinela(valor, padrao = '') {
  if (valor === null || valor === undefined || valor === '') return padrao;
  const chave = MAPA[normalizar(valor)];
  return chave ? i18n.t(chave) : valor;
}

/** O valor é o sentinela de "não informado"? Útil para esconder o campo. */
export function ehNaoInformado(valor) {
  return normalizar(valor) === 'nao informado';
}

export default exibirSentinela;
